import ApiService from "@/api";
import WeeekOptionsGetProjectOptionsRequest from "../models/WeeekOptionsGetProjectOptionsRequest";
import WeeekOptionsGetProjectOptionsResponse from "../models/WeeekOptionsGetProjectOptionsResponse";
import { ResponseModel } from "tir-pm-file-upload-manager";
import {
  WeeekOptionsUpdateApiKeyRequest,
  WeeekOptionsUpsertPrioritiesRequest,
  WeeekOptionsUpsertPrioritiesResponse,
  WeeekOptionsUpsertStatusesRequest,
  WeeekOptionsUpsertStatusesResponse,
  WeeekOptionsUpsertTagsRequest,
  WeeekOptionsUpsertTagsResponse,
  WeeekOptionsUpsertTypesRequest,
  WeeekOptionsUpsertTypesResponse,
} from "../models";

export class AdapterService {
  private readonly api = new ApiService();

  /**Получить настройки проекта */
  getProjectOptionsAsync(
    request: WeeekOptionsGetProjectOptionsRequest,
  ): Promise<ResponseModel<WeeekOptionsGetProjectOptionsResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetProjectOptionsResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetProjectOptionsResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getProjectOptionsAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }

  /**Обновить ключ апи */
  updateApiKeyAsync(request: WeeekOptionsUpdateApiKeyRequest): Promise<ResponseModel<Boolean>> {
    return new Promise<ResponseModel<Boolean>>(async (resolve) => {
      const result = new ResponseModel<Boolean>();

      await this.api.Weeek.WeeekOptionsWsController.updateApiKeyAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }

  /**
   * * Добавление/удаление/изменение сопоставления статусов
   */
  upsertStatusesWeeek(
    request: WeeekOptionsUpsertStatusesRequest,
  ): Promise<ResponseModel<WeeekOptionsUpsertStatusesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsUpsertStatusesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsUpsertStatusesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.upsertStatusesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Добавление/удаление/изменение сопоставления приоритетов
   */
  upsertPrioritiesAsync(
    request: WeeekOptionsUpsertPrioritiesRequest,
  ): Promise<ResponseModel<WeeekOptionsUpsertPrioritiesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsUpsertPrioritiesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsUpsertPrioritiesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.upsertPrioritiesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Добавление/удаление/изменение сопоставления типов
   */
  async upsertTypesAsync(
    request: WeeekOptionsUpsertTypesRequest,
  ): Promise<ResponseModel<WeeekOptionsUpsertTypesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsUpsertTypesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsUpsertTypesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.upsertTypesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Добавление/удаление/изменение сопоставления типов
   */
  async upsertTagsAsync(
    request: WeeekOptionsUpsertTagsRequest,
  ): Promise<ResponseModel<WeeekOptionsUpsertTagsResponse>> {
    return new Promise<ResponseModel<WeeekOptionsUpsertTagsResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsUpsertTagsResponse>();

      await this.api.Weeek.WeeekOptionsWsController.upsertTagsAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
}
